export const AMOUNT = 'amount';
export const CALCULATION_TYPE_ID = 'calculationTypeId';
export const CONDITION_TYPE_ID = 'conditionTypeId';
export const VALID_FROM_TO = 'validFromTo';
export const VALID_FROM = 'validFrom'; //TODO check if needed
export const VALID_TO = 'validTo'; //TODO check if needed
export const COUNTRY_ID = 'countryId';
export const DESCRIPTION = 'description';
export const CUSTOMER_TYPE_ID = 'customerTypeId';
export const DISTRIBUTION_TYPE_ID = 'distributionTypeId';
export const DIVISION_ID = 'divisionId';
export const CUSTOMER_ID = 'customerId';
export const ARTICLE_CATEGORY_ID = 'articleCategoryId';
export const ARTICLE_BRAND_ID = 'articleBrandId';
export const ARTICLE_ID = 'articleId';
